// src/screens/sales/promo/Promo.tsx

import React from 'react'
import classes from './Promo.module.sass'
import { Helmet } from 'react-helmet-async'
import { Button } from '../../../common/components/button/Button'
import { List } from './components/list/List'
import { Modal } from '../../../common/components/modal/Modal'
import { Form } from './components/form/Form'
import { usePromo } from './hooks/usePromo'
import { Details } from './components/details/Details'
import Search from '../../../common/components/listControl/search/Search'
import { MailingConfirmContent } from './components/mailingConfirmContent/MailingConfirmContent'
import { useSearchWithDebounce } from '../../../common/hooks/useSearchWithDebounce'
import { PromoInterface } from '../../../common/types/interfaces'

export const Promo = () => {
  const {
    getList,
    modalActive,
    setModalActive,
    startCreate,
    startEdit,
    edit,
    data,
    setData,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    loading,
    startMailing,
    modalActive1,
    setModalActive1,
  } = usePromo()

const {
  searchQuery,
  handleSearch,
  clearSearch,
  filteredItems,
} = useSearchWithDebounce<PromoInterface>({
  items: list,
  searchFields: ['id', 'name', 'description', 'discountCode'],
})

  return (
    <div className={classes.container}>
      <Helmet>
        <title>{`Справочник промо акций`}</title>
        <meta name="description" content={`Справочник промо акций`} />
      </Helmet>
      <div className={classes.titleWithButtons}>
        <div className={classes.header}>Промо акции</div>
        <Button onClick={startCreate} text="Создать" />
      </div>

      <div className={classes.searchContainer}>
        <Search
          onChange={handleSearch}
          clear={clearSearch}
          value={searchQuery}
          placeHolder="Поиск по id, названию, описанию или коду"
        />
      </div>

      <List
        showDetails={showDetails}
        startEdit={startEdit}
        list={filteredItems}
        loading={loading}
        startMailing={startMailing}
      />

      <Modal modalActive={modalActive} setModalActive={setModalActive}>
        <Form
          edit={edit}
          data={data}
          setData={setData}
          getList={getList}
          setModalActive={setModalActive}
          el={current}
        />
      </Modal>
      <Modal modalActive={modalActive1} setModalActive={setModalActive1}>
        <MailingConfirmContent current={current} setModalActive={setModalActive1} getList={getList} />
      </Modal>

      <Modal modalActive={detailsModalActive} setModalActive={setDetailsModalActive}>
        <Details el={current} />
      </Modal>
    </div>
  )
}